import { allowManageLicenseStatus, allowRequestLicenseCheck, allowViewEcl, allowViewLicenseStatus, } from '../../../../backend/features/permissions/shared';
import { isTrainFeatureEnabled } from '../../../../ui/utils';
import { requireAnyOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
export function createCredentialingFormRules(t, settings, userState) {
    var _a, _b;
    const rules = [];
    if (!userState || ((_a = userState.credentialing) === null || _a === void 0 ? void 0 : _a.featureFlags.includes('licenseCheck'))) {
        rules.push({
            type: 'automaticLicenseStatusPermission',
            label: t('rules.automaticLicenseStatusPermission'),
            applyRule: (config, _data, formParams) => {
                const allowView = allowViewLicenseStatus(userState, formParams === null || formParams === void 0 ? void 0 : formParams.id);
                const allowChange = allowManageLicenseStatus(userState);
                config.disabled = true;
                config.hidden = !allowView && !allowChange;
            },
        });
        rules.push({
            type: 'manualLicenseStatusPermission',
            label: t('rules.manualLicenseStatusPermission'),
            applyRule: (config, _data, formParams) => {
                const allowView = allowViewLicenseStatus(userState, formParams === null || formParams === void 0 ? void 0 : formParams.id);
                const allowChange = allowManageLicenseStatus(userState) ||
                    (allowRequestLicenseCheck(userState) && requireAnyOrgPermission(userState, 'manage-members'));
                config.disabled = !allowChange;
                config.hidden = !allowView && !allowChange;
            },
        });
    }
    if (!userState || ((_b = userState.credentialing) === null || _b === void 0 ? void 0 : _b.featureFlags.includes('credential'))) {
        rules.push({
            type: 'eclPermission',
            label: t('rules.eclPermission'),
            applyRule: (config) => {
                const allowView = allowViewEcl(userState);
                config.disabled = true;
                config.hidden = !allowView;
            },
        });
    }
    const isTrainEnabled = isTrainFeatureEnabled(userState);
    rules.push({
        type: 'credentialingTRAINFieldPrefix',
        label: t('rules.credentialingTRAINFieldPrefix'),
        applyRule: (config) => {
            var _a;
            const configData = config;
            if (!configData.children) {
                return;
            }
            const personalInfoWidget = configData.children.find(({ key }) => key === '!personalInfo');
            const modalTrainUsername = (personalInfoWidget === null || personalInfoWidget === void 0 ? void 0 : personalInfoWidget.modal.children)
                ? personalInfoWidget.modal.children.find(({ key }) => key === 'trainUsername')
                : undefined;
            const modalTrainUsernameConfig = modalTrainUsername;
            if (isTrainEnabled && modalTrainUsernameConfig) {
                const esarVhpCode = (_a = settings.esarVhp) === null || _a === void 0 ? void 0 : _a.clientCode;
                modalTrainUsernameConfig.label = modalTrainUsernameConfig.label.replace(new RegExp('^TRAIN '), `${esarVhpCode}TRAIN `);
            }
            if (!isTrainEnabled && personalInfoWidget) {
                personalInfoWidget.modal.children = personalInfoWidget.modal.children.filter(({ key }) => key !== 'trainUsername');
            }
        },
    });
    return rules;
}
